import React, { Component } from "react";
import config from "../../../config.json";

const env = process.env.REACT_APP_ENVIRONMENT || "stage";
const BACKOFICCE_V2 = config.backofficeV2[env];

export default class ListStaff extends Component {
  componentDidMount() {
    window.location.href = `${BACKOFICCE_V2}/staff`;
  }

  render() {
    return <h1>Redirecionando para Acessos...</h1>;
  }
}
